import { Store } from "@store";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import GuestUserModal from "src/globalModule/components/guestUserModal";
import CommunityPage from "../components/communityPage";
import CommunitySearchBox from "../components/communitySearchBox";
import { getListCommunity } from "../queries/community.queries";
import { useDebouncedCallback } from "use-debounce";
const CommunityView = ({
  data
}) => {
  const router = useRouter();
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const [communitiesState, setCommunitiesState] = useState(data);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [communityPage, setCommunityPage] = useState(0);
  const [hasMoreCommunities, setHasMoreCommunities] = useState(true);
  //const [openUnauthorizedModal, setOpenUnauthorizedModal] = useState(false);
  const [communityID, setCommunityID] = useState("");
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);

  // Debounce callback
  const debounced = useDebouncedCallback(
  // function
  value => {
    setDebouncedSearch(value);
  },
  // delay in ms
  500);
  const handleOpenUnauthorizedModal = () => {
    // if (smallScreen) setLoginModalOpen(true);
    // else setOpenUnauthorizedModal(!openUnauthorizedModal);
    setLoginModalOpen(true);
  };
  let currentLink = "/" + router.pathname.split("/")[1];
  const {
    params
  } = router.query;
  params?.map(query => {
    currentLink += `/${query}`;
  });
  useEffect(() => {
    async function getData() {
      const obj = {
        search: debouncedSearch,
        page: 0
      };
      const response = await getListCommunity(obj);
      if (response.data?.length === 0) {
        setHasMoreCommunities(false);
        setCommunitiesState(null);
        setCommunityPage(0);
      } else {
        setCommunitiesState(response.data);
        setCommunityPage(cur => cur + 1);
        setHasMoreCommunities(true);
      }
    }
    getData();
  }, [debouncedSearch, loggedInUser.accessToken]);
  async function updateData() {
    const obj = {
      search: search,
      page: communityPage
    };
    const response = await getListCommunity(obj);
    if (!response.err && response.data) {
      if (response.data.length === 0) {
        setHasMoreCommunities(false);
      } else {
        setCommunitiesState(currentData => [...currentData, ...response.data]);
        setCommunityPage(communityPage + 1);
        setHasMoreCommunities(true);
      }
    } else {
      setHasMoreCommunities(false);
    }
  }
  return <>
      <CommunitySearchBox setSearchData={setSearch} setCommunityPage={setCommunityPage} setHasMoreCommunities={setHasMoreCommunities} debounced={debounced} data-sentry-element="CommunitySearchBox" data-sentry-source-file="communityView.jsx" />
      <CommunityPage communitiesState={communitiesState} setCommunitiesState={setCommunitiesState} updateData={updateData} hasMore={hasMoreCommunities} toggleModal={handleOpenUnauthorizedModal} setCommunityID={setCommunityID} data-sentry-element="CommunityPage" data-sentry-source-file="communityView.jsx" />

      {/* {smallScreen && openUnauthorizedModal && (
        <GuestPopup
          open={openUnauthorizedModal}
          toggleModal={handleOpenUnauthorizedModal}
          link={currentLink}
        ></GuestPopup>
       )} */}

      {/* {!smallScreen && openUnauthorizedModal && (
        <UtsavModal
          open={openUnauthorizedModal}
          toggleModal={handleOpenUnauthorizedModal}
          heading="Login / Sign up to continue"
          message="To access this feature you need to register yourself"
          acceptMsg="Continue"
          onAccept={() => setLoginModalOpen(true)}
          rejectMsg="Cancel"
        />
       )} */}
      {isLoginModalOpen && <GuestUserModal isLoginModalOpen={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen} />}
    </>;
};
export default CommunityView;